import { number, string } from "yup";
import { signupValidationSchema } from "./signupValidationSchema";

export const createSubagentValidationSchema = signupValidationSchema
    .pick(["username", "phone", "email", "first_name", "last_name", "password"])
    .shape({
        account_holder: string().when("$configObj", ([config], schema) => {
            if (config.account_holder.required) {
                return schema.required(config.t("validation_err_required"));
            }
            return schema.notRequired().transform((value: string) => (value ? value : null));
        }),
        bank_name: string().when("$configObj", ([config], schema) => {
            if (config.bank_name.required) {
                return schema.required(config.t("validation_err_required"));
            }
            return schema.notRequired().transform((value: string) => (value ? value : null));
        }),
        account_number: string().when("$configObj", ([config], schema) => {
            if (config.account_number.required) {
                return schema.required(config.t("validation_err_required"));
            }
            return schema.notRequired().transform((value: string) => (value ? value : null));
        }),
        sport_cashback: number()
            .when("$configObj", ([config], schema) =>
                schema.typeError(config.t("validation_err_required")),
            )
            .when("$configObj", ([config], schema) =>
                schema.min(
                    0,
                    config.t("validation_err_minValue", {
                        value: 0,
                    }),
                ),
            )
            .when("$configObj", ([config], schema) =>
                schema.max(
                    config.sport_cashback.max,
                    config.t("validation_err_maxValue", {
                        value: config.sport_cashback.max,
                    }),
                ),
            ),
        live_casino_cashback: number()
            .when("$configObj", ([config], schema) =>
                schema.typeError(config.t("validation_err_required")),
            )
            .when("$configObj", ([config], schema) =>
                schema.min(
                    0,
                    config.t("validation_err_minValue", {
                        value: 0,
                    }),
                ),
            )
            .when("$configObj", ([config], schema) =>
                schema.max(
                    config.live_casino_cashback.max,
                    config.t("validation_err_maxValue", {
                        value: config.live_casino_cashback.max,
                    }),
                ),
            ),
        slots_cashback: number()
            .when("$configObj", ([config], schema) =>
                schema.typeError(config.t("validation_err_required")),
            )
            .when("$configObj", ([config], schema) =>
                schema.min(
                    0,
                    config.t("validation_err_minValue", {
                        value: 0,
                    }),
                ),
            )
            .when("$configObj", ([config], schema) =>
                schema.max(
                    config.slots_cashback.max,
                    config.t("validation_err_maxValue", {
                        value: config.slots_cashback.max,
                    }),
                ),
            ),
        agent_code: string(),
    });
